import Preloader from "../helper/Preloader";
import BrandSectionOne from "../components/BrandSectionOne";
import BreadcrumbEight from "../components/BreadcrumbEight";
import Contact from "../components/Contact";
const ContactPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* BreadcrumbEight */}
      <BreadcrumbEight />

      {/* Contact */}
      <Contact />

      {/* BrandSectionOne */}
      <BrandSectionOne />
    </>
  );
};

export default ContactPage;
